import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'store';
import { useDispatch } from 'react-redux';
import { communityActions } from 'store/community';
import { useRouter } from 'next/router';
import styled from 'styled-components';

var CommunitySideMenu = function CommunitySideMenu(_ref) {
  var selected = _ref.selected;
  var my = useSelector(function (state) {
    return state.accounts.user;
  });
  var user = useSelector(function (state) {
    return state.community.community_select_user;
  });
  var regions = useSelector(function (state) {
    return state.space.regions;
  }).results;
  var dispatch = useDispatch();
  var router = useRouter();

  var selectedClass = function selectedClass(value) {
    return selected === value ? 'selected' : '';
  };

  var clickRemoveUser = function clickRemoveUser() {
    dispatch(communityActions.setCommunitySelectUser(null));
  };

  var clickRouteUser = function clickRouteUser(id) {
    router.push("/community/user/".concat(id));
  };

  var clickRoute = function clickRoute(url) {
    router.push(url);
  };

  return /*#__PURE__*/_jsxs("aside", {
    className: "selected",
    children: [/*#__PURE__*/_jsx("h2", {
      children: "\uCEE4\uBBA4\uB2C8\uD2F0"
    }), /*#__PURE__*/_jsx("div", {
      style: {
        border: 0,
        padding: 0
      },
      children: /*#__PURE__*/_jsxs(SideMenuWrapper, {
        children: [/*#__PURE__*/_jsx(Menu, {
          className: selectedClass('최신글'),
          children: /*#__PURE__*/_jsx(Anchor, {
            onClick: function onClick() {
              return clickRoute('/community/new_post');
            },
            style: {
              cursor: 'pointer'
            },
            children: "\uCD5C\uC2E0\uAE00"
          })
        }), /*#__PURE__*/_jsx(Menu, {
          className: selectedClass('공지사항'),
          children: /*#__PURE__*/_jsx(Anchor, {
            onClick: function onClick() {
              return clickRoute('/community/notice');
            },
            style: {
              cursor: 'pointer'
            },
            children: "\uACF5\uC9C0\uC0AC\uD56D"
          })
        }), /*#__PURE__*/_jsx(Menu, {
          className: selectedClass('이벤트 & 모임'),
          children: /*#__PURE__*/_jsx(Anchor, {
            onClick: function onClick() {
              return clickRoute('/community/event');
            },
            style: {
              cursor: 'pointer'
            },
            children: "\uC774\uBCA4\uD2B8 & \uBAA8\uC784"
          })
        }), /*#__PURE__*/_jsx(Menu, {
          className: selectedClass('owner'),
          children: /*#__PURE__*/_jsx(Anchor, {
            onClick: function onClick() {
              return clickRoute("/community/user/".concat(my.id));
            },
            style: {
              cursor: 'pointer'
            },
            children: "\uB0B4\uAC00 \uC791\uC131\uD55C \uAE00"
          })
        }), regions.length > 0 && regions.map(function (region) {
          return /*#__PURE__*/_jsx(Menu, {
            className: selectedClass(region.name),
            children: /*#__PURE__*/_jsx(Anchor, {
              onClick: function onClick() {
                return clickRoute("/community/cluster/".concat(region.id));
              },
              style: {
                cursor: 'pointer'
              },
              children: region.name
            })
          }, region.id);
        }), user !== null && /*#__PURE__*/_jsxs(Menu, {
          className: selectedClass('user'),
          children: [/*#__PURE__*/_jsx(Anchor, {
            onClick: function onClick() {
              return clickRouteUser(user.id);
            },
            style: {
              cursor: 'pointer'
            },
            children: user.profile.display_name
          }), /*#__PURE__*/_jsx("button", {
            type: "button",
            className: "btn-delete",
            onClick: clickRemoveUser,
            children: /*#__PURE__*/_jsx("span", {
              children: "\uC0AD\uC81C"
            })
          })]
        })]
      })
    })]
  });
};

var SideMenuWrapper = styled.ul.withConfig({
  displayName: "CommunitySideMenu__SideMenuWrapper",
  componentId: "sc-1tlve3a-0"
})(["@media screen and (max-width:786px){display:flex;overflow-x:scroll;padding-bottom:16px;}"]);
var Menu = styled.li.withConfig({
  displayName: "CommunitySideMenu__Menu",
  componentId: "sc-1tlve3a-1"
})(["@media screen and (max-width:786px){flex:1 0;padding:4px 12px !important;margin-right:12px;justify-content:center;text-align:center;border-radius:20px;font-size:14px;font-weight:bold;background-color:", ";color:", ";white-space:nowrap;}"], function (props) {
  return props.className === 'selected' ? '#111' : 'unset';
}, function (props) {
  return props.className === 'selected' ? 'white' : '#111';
});
var Anchor = styled.a.withConfig({
  displayName: "CommunitySideMenu__Anchor",
  componentId: "sc-1tlve3a-2"
})(["@media screen and (max-width:786px){color:inherit;}"]);
export default CommunitySideMenu;